/**
 * @deprecated This page is deprecated as of October 2025.
 *
 * Campaign creation has been moved inline into the CampaignsTab component
 * within the SMS Dashboard to match the UI pattern used by TriggersTab.
 *
 * This route now redirects to /sms-campaigns for backwards compatibility
 * with external links and bookmarks. Users can create campaigns by clicking
 * the "Create Campaign" button in the Campaigns tab.
 *
 * Related components:
 * - New location: src/components/sms/campaign/CampaignForm.tsx (reusable form)
 * - Integration: src/components/sms/dashboard/improved/tabs/CampaignsTab.tsx
 *
 * Migration completed: 2025-10-09
 */

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/auth';
import Navigation from '@/components/Navigation';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Info } from 'lucide-react';

const CampaignCreate = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  // Redirect to campaigns dashboard
  useEffect(() => {
    if (isAuthenticated) {
      // Redirect to SMS campaigns dashboard
      // Users can click "Create Campaign" button there
      navigate('/sms-campaigns', { replace: true });
    } else {
      // If not authenticated, redirect to auth
      navigate('/auth', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  // Show brief message while redirecting
  return (
    <Navigation>
      <div className="page-container max-w-2xl mx-auto p-4 md:p-6">
        <div className="py-8">
          <Alert>
            <Info className="h-4 w-4" />
            <AlertDescription>
              Redirecting to SMS Campaigns dashboard...
            </AlertDescription>
          </Alert>
        </div>
      </div>
    </Navigation>
  );
};

export default CampaignCreate;
